import { themes } from './index';

export interface ITheme {
  [key: string]: string;
}

export interface IThemes {
  [key: string]: ITheme;
}

export interface IMappedTheme {
  [key: string]: string | null;
}

export const mapTheme = (variables: ITheme): IMappedTheme => {
  return {
    '--color-primary': variables?.primary || '',
    '--color-secondary': variables?.secondary || '',
    '--color-positive': variables?.positive || '',
    '--color-negative': variables?.negative || '',
    '--color-text-primary': variables?.textPrimary || '',
    '--color-text-secondar': variables?.textSecondary || '',
    '--background-primary': variables?.backgroundPrimary || '',
    '--background-sec': variables?.backgroundSecondary || '',
    '--color-button-primary': variables?.primaryButton || '',
    '--color-button-secondary': variables?.secondaryButton || '',
    '--color-button': variables?.button || '',
    '--color-error': variables?.error || '',
    '--color-on-primary': variables?.onPrimary || '',
    '--color-primary-container': variables?.primaryContainer || '',
    '--color-on-primary-container': variables?.onPrimaryContainer || '',
    '--color-on-secondary': variables?.onSecondary || '',
    '--color-secondary-container': variables?.secondaryContainer || '',
    '--color-on-secondary-container': variables?.onSecondaryContainer || '',
    '--color-tertiary': variables?.tertiary || '',
    '--color-on-tertiary': variables?.onTertiary || '',
    '--color-tertiary-container': variables?.tertiaryContainer || '',
    '--color-on-tertiary-container': variables?.onTertiaryContainer || '',
    '--color-on-error': variables?.onError || '',
    '--color-error-container': variables?.errorContainer || '',
    '--color-on-error-container': variables?.onErrorContainer || '',
    '--color-background': variables?.background || '',
    '--color-on-background': variables?.onBackground || '',
    '--color-surface': variables?.surface || '',
    '--color-on-surface': variables?.onSurface || '',
    '--color-surface-variant': variables?.surfaceVariant || '',
    '--color-on-surface-variant': variables?.onSurfaceVariant || '',
    '--color-outline': variables?.outline || '',
    '--color-outline-variant': variables?.outlineVariant || '',
    '--color-shadow': variables?.shadow || '',
    '--color-scrim': variables?.scrim || '',
    '--color-inverse-surface': variables?.inverseSurface || '',
    '--color-inverse-on-surface': variables?.inverseOnSurface || '',
    '--color-inverse-primary': variables?.inversePrimary || '',
  };
};

export const applyTheme = (theme: string): void => {
  const themeObject: IMappedTheme = mapTheme(themes[theme]);
  if (!themeObject) return;

  const root = document.documentElement;

  Object.keys(themeObject).forEach(property => {
    if (property === 'name') {
      return;
    }

    root.style.setProperty(property, themeObject[property]);
  });
};

export const extend = (extending: ITheme, newTheme: ITheme): ITheme => {
  return { ...extending, ...newTheme };
};

export const applyWithThemeObject = (theme: ITheme): void => {
  const themeObject: IMappedTheme = mapTheme(theme);
  const root = document.documentElement;

  Object.keys(themeObject).forEach(property => {
    if (property === 'name') {
      return;
    }

    root.style.setProperty(property, themeObject[property]);
  });
};
